import { gql } from '@apollo/client';
export const PROGRAM_FIELDS = gql `
  fragment ProgramFields on Program {
    id
    createdAt
    updatedAt
    clientId
    userId
    status
    programLevelId
    programLevelName
    fieldOfStudyId
    fieldOfStudyName
    programName
    startDate
    estCompDate
    approvalDate
    employeeId
    workflowRunId
    description
    purpose {
      selections
      other
      isActive
      isRequired
    }
    schoolId
    schoolName
    schoolCountryCode
    schoolCountryId
    documents {
      docs {
        s3Key
        name
        date
        fileSize
      }
    }
    client {
      name
    }
    employee {
      id
      userId
      uniqueId
      firstName
      lastName
      email
    }
    requestNum
    otherSchool
    otherSchoolCountryCode
    otherSchoolCountryId
    otherFieldOfStudy
    custom1
    isSingleExpense
  }
`;
export const PROGRAMS = gql `
  ${PROGRAM_FIELDS}
  query PROGRAMS($spec: ProgramSpec!) {
    programs(spec: $spec) {
      ...ProgramFields
    }
  }
`;
export const SAVE_PROGRAM = gql `
  ${PROGRAM_FIELDS}
  mutation SAVE_PROGRAM($input: ProgramInput!) {
    saveProgram(input: $input) {
      success
      program {
        ...ProgramFields
      }
      paymentRequest
      messages {
        value
        params
        type
      }
    }
  }
`;
export const UPDATE_PROGRAM_SCHOOL_COUNTRY = gql `
  ${PROGRAM_FIELDS}
  mutation UPDATE_PROGRAM_SCHOOL_COUNTRY($input: UpdateProgramSchoolCountryInput!) {
    updateProgramSchoolCountry(input: $input) {
      ...ProgramFields
    }
  }
`;
export const DELETE_PROGRAM = gql `
  ${PROGRAM_FIELDS}
  mutation DELETE_PROGRAM($id: Int!) {
    deleteProgram(id: $id) {
      ...ProgramFields
    }
  }
`;
export const UPDATE_PROGRAM_STATUS = gql `
  ${PROGRAM_FIELDS}
  mutation UPDATE_PROGRAM_STATUS($input: ProgramStatusInput!) {
    updateProgramStatus(input: $input) {
      ...ProgramFields
    }
  }
`;
export const SAVE_SINGLE_EXPENSE = gql `
  ${PROGRAM_FIELDS}
  mutation SAVE_SINGLE_EXPENSE($input: SingleExpenseInput!) {
    saveSingleExpense(input: $input) {
      success
      program {
        ...ProgramFields
      }
      paymentRequest {
        id
        status
      }
      messages {
        value
        params
        type
      }
    }
  }
`;
